import {vrmVueModule} from '../module';
import {
    NOTIFICATION_TYPE_INFO,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_DANGER,
    NOTIFICATION_TYPE_ERROR,
    NOTIFICATION_TYPE_WARNING,
    NOTIFICATIONS,
    VrmNotification
} from '@/vue/store/modules/notifications';
import store from '@/vue/store';
import VrmNotificationModal from "../../vue/components/modals/VrmNotificationModal";

vrmVueModule
    .constant('vrmNotificationType', {
        INFO: NOTIFICATION_TYPE_INFO,
        SUCCESS: NOTIFICATION_TYPE_SUCCESS,
        DANGER: NOTIFICATION_TYPE_DANGER,
        ERROR: NOTIFICATION_TYPE_ERROR,
        WARNING: NOTIFICATION_TYPE_WARNING,
    })
    .service('vrmNotificationsService', vrmNotificationsService);

/** @ngInject */
function vrmNotificationsService(VrmModalService) {
    return {
        add(note,modal=false) {
            const notification = new VrmNotification(note);
            store.dispatch(NOTIFICATIONS.ADD, {notification, modal}).then(()=>{
                if (modal)
                    this.openNext()
            });
            return notification.id;
        },
        remove(id,modal=false) {
            store.dispatch(NOTIFICATIONS.REMOVE, {id,modal}).then(()=>{
                if (modal)
                    this.openNext()
            });
        },
        openNext() {
            const notification = store.getters[NOTIFICATIONS.GET_FIRST];
            if (notification !== null && !store.getters[NOTIFICATIONS.OPEN]){
                store.commit(NOTIFICATIONS.OPEN,true)
                VrmModalService.openVueModal(VrmNotificationModal,{},{closeOnBgClick:false}).then(()=>{
                    store.commit(NOTIFICATIONS.OPEN,false)
                    this.remove(notification.id,true)
                })
            }
        }
    };
}
